import { render, staticRenderFns } from "./assemble_detail.vue?vue&type=template&id=6ec82a37&scoped=true"
import script from "./assemble_detail.vue?vue&type=script&lang=js"
export * from "./assemble_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec82a37",
  null
  
)

export default component.exports